import React, { useEffect } from 'react';
import type { FaixaDePreco } from '../../../../../@types/IPA/PrecoPsicologico';
import { useExcluirFaixa } from '../../../../../hooks/usePrecoPsicologico';
import { usePrecoPsicologicoStore } from '../../../../../store/usePrecoPsicologicoStore';
import { formatCurrencyToPtBr } from '../../../../../utils/currency';
import { LABELS_ARREDONDAMENTO, LABELS_DIGITOS } from '../../constants';

export function ModalConfirmarExclusao() {
  const { modalExclusaoAberto, faixaSelecionada, fecharModalExclusao } = usePrecoPsicologicoStore();
  const { mutate: excluir, isLoading } = useExcluirFaixa();
  const usuarioId = JSON.parse(localStorage.getItem('usuario') || '{}')?.email ?? '';

  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape' && !isLoading) fecharModalExclusao();
    }
    if (modalExclusaoAberto) document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [modalExclusaoAberto, isLoading, fecharModalExclusao]);

  if (!modalExclusaoAberto || !faixaSelecionada) return null;

  const faixa = faixaSelecionada as FaixaDePreco;
  const finais = faixa.finaisPermitidos.join(', ');

  function handleConfirmar() {
    excluir(
      { id: faixa.id, data: { usuarioId } },
      { onSuccess: fecharModalExclusao }
    );
  }

  return (
    <div
      className="modal-exclusao__backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-exclusao-titulo"
      onClick={() => !isLoading && fecharModalExclusao()}
    >
      <div className="modal-exclusao__caixa" onClick={e => e.stopPropagation()}>
        <h2 id="modal-exclusao-titulo" className="modal-exclusao__titulo">
          Excluir faixa de preço
        </h2>

        <div className="modal-exclusao__resumo">
          <div className="modal-exclusao__linha">
            <span className="modal-exclusao__label">Faixa:</span>
            <span>{formatCurrencyToPtBr(faixa.valorDe)} a {formatCurrencyToPtBr(faixa.valorAte)}</span>
          </div>
          <div className="modal-exclusao__linha">
            <span className="modal-exclusao__label">Dígitos:</span>
            <span>{LABELS_DIGITOS[faixa.tipo] ?? '-'}</span>
          </div>
          <div className="modal-exclusao__linha">
            <span className="modal-exclusao__label">Finais:</span>
            <span>{finais || '-'}</span>
          </div>
          <div className="modal-exclusao__linha">
            <span className="modal-exclusao__label">Arredondamento:</span>
            <span>{LABELS_ARREDONDAMENTO[faixa.opcaoArredondamento] ?? '-'}</span>
          </div>
        </div>

        <div className="modal-exclusao__acoes">
          <button
            type="button"
            className="modal-exclusao__btn modal-exclusao__btn--cancelar"
            onClick={fecharModalExclusao}
            disabled={isLoading}
          >
            CANCELAR
          </button>
          <button
            type="button"
            className="modal-exclusao__btn modal-exclusao__btn--excluir"
            onClick={handleConfirmar}
            disabled={isLoading}
          >
            {isLoading ? 'EXCLUINDO...' : 'EXCLUIR'}
          </button>
        </div>
      </div>
    </div>
  );
}
